var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-none uppercase p-2 w-10 h-10 text-white text-center rounded-full",class:_vm.color},[_vm._v("\n  "+_vm._s(_vm.initials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }